import { useCallback, useEffect } from 'react'

import { ReportSection, ResetLink } from 'app/common/templates-next/report-template'
import ReportFilterForm from 'app/common/templates-next/report-template/report-filter-form'
import ReportFilterLayout from 'app/common/templates-next/report-template/report-filter-layout'
import { DetailsBox, detailsBoxID } from 'app/common/ui-next/_filter-compilations/details'

// import { useUser } from 'app/dataProviders/user/hooks'
import { useReportPerform } from 'app/dataProviders/reports/hooks'
import { ReportType } from 'app/dataTypes/reports'
import { canMailingOnly, MailingBox } from 'app/common/ui-next/_filter-compilations/mailing'

import {
  FoodTypesFilter,
  OrderByClassesDetailsGroupFilter,
  OrgTypesFilter,
  OrgsFilter,
  PeriodFilter,
  CafeteriaManagerSignatoresFilter,
  FoodResponsibleSignatoresFilter,
  AccountantSignatoresFilter,
  BuildingsFilter,
  DateFilter,
} from './filterItems'

import { filterInit, resetToDefaultAll } from './filter-init'
import { OrderByClassesFilterKey as FilterKey } from './filterItems/types'
import styles from './Filters.scss'

const isMailingOnly = (formData: FormData) => !!canMailingOnly(formData)

type Props = {
  onReportId: (reportID: string | null) => void
}

export const Filters = ({ onReportId }: Props) => {
  // const { email, loading } = useUser()

  const { perform } = useReportPerform({
    onReportId,
    isMailingOnly,
  })

  const resetAll = () => {
    resetToDefaultAll()
  }

  const performWithAdditionalData = useCallback(
    async (formData: FormData) => {
      await perform({ formData, reportType: ReportType.OrdersByClasses })
    },
    [perform],
  )

  useEffect(() => {
    return filterInit()
  }, [])

  return (
    <ReportSection
      header="Фильтры"
      headerBar={<ResetLink onClick={resetAll}>{'Сбросить все фильтры'}</ResetLink>}
      resetStickyShift={false}
      skipPadding
    >
      <div className={styles.formContent}>
        <ReportFilterForm onSubmit={performWithAdditionalData} submitButtonTitle="Сформировать">
          {(pending) => (
            <ReportFilterLayout
              column1={
                <>
                  <OrgTypesFilter id={FilterKey.OrgType} pending={pending} />
                  <OrgsFilter id={FilterKey.Org} pending={pending} />
                  <BuildingsFilter id={FilterKey.Building} pending={pending} />
                  {/* отключены фильтры для для группировки по "категориям льгот и комплектам" */}
                  {/*
                  <SalePointsFilter id={FilterKey.SalePoints} pending={pending} />
                  <CustomerTypeFilter id={FilterKey.CustomerType} pending={pending} /> */}
                  <DetailsBox id={FilterKey.Details} />
                  <OrderByClassesDetailsGroupFilter
                    id={FilterKey.GroupBy}
                    pending={pending}
                    visibleFromBox={detailsBoxID}
                  />
                </>
              }
              column2={
                <>
                  <DateFilter id={FilterKey.Date} pending={pending} />
                  <PeriodFilter id={FilterKey.Period} pending={pending} />
                  <FoodTypesFilter id={FilterKey.OperationAge} pending={pending} />
                  <FoodResponsibleSignatoresFilter
                    id={FilterKey.FoodResponsibleSignatory}
                    pending={pending}
                  />
                  <CafeteriaManagerSignatoresFilter
                    id={FilterKey.CafeteriaManagerSignatory}
                    pending={pending}
                  />
                  <AccountantSignatoresFilter
                    id={FilterKey.AccountantSignatory}
                    pending={pending}
                  />
                  <MailingBox visibleFromBox={detailsBoxID} disabled={pending} />
                </>
              }
            />
          )}
        </ReportFilterForm>
      </div>
    </ReportSection>
  )
}
